import { DefaultService } from '@/services/DefaultService';

export default class AssTipoVisitaAssuntoVisitaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(ass, contexto = 'agro') {
        return this._http
            .post(
                `${this._env}/${contexto}/asstipovisitaassuntovisita/updatesituacao`,
                ass,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAll(column, order, page, limit, situacao, idassunto, contexto = 'agro', ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/${contexto}/asstipovisitaassuntovisita.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idassunto=${idassunto}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    findNaoAssociados(column, order, page, limit, id, contexto = 'agro', ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/${contexto}/asstipovisitaassuntovisita/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idassunto=${id}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    find(id) {
        return this._http
            .get(`${this._env}/agro/asstipovisitaassuntovisita/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    save(form, contexto = 'agro') {
        return this._http
            .post(`${this._env}/${contexto}/asstipovisitaassuntovisita`, form, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }
}
